import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const UserModify = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  // const userIdInputRef = useRef();
  const fullNameInputRef = useRef();
  const userNameInputRef = useRef();
  const emailInputRef = useRef();

  const [roleListToBeSelect, setRoleListToBeSelect] = useState([]);
  const [roleList, setRoleList] = useState([]);

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [dataToBeSelect, setDataToBeSelect] = useState([]);

  useEffect(() => {
    if (props.dataToBeSelect !== undefined && props.dataToBeSelect !== null) {
      setDataToBeSelect({
        Organization:
          props.dataToBeSelect.Organization === null
            ? []
            : props.dataToBeSelect.Organization,
      });
    }
  }, [props.dataToBeSelect]);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        USER_ID: props.editData.USER_ID === null ? "" : props.editData.USER_ID,
        USER_FULL_NAME:
          props.editData.USER_FULL_NAME === null
            ? ""
            : props.editData.USER_FULL_NAME,
        USER_SHORT_NAME:
          props.editData.USER_SHORT_NAME === null
            ? ""
            : props.editData.USER_SHORT_NAME,
        EMAIL: props.editData.EMAIL === null ? "" : props.editData.EMAIL,
        ROLE_ID: props.editData.ROLE_ID === null ? "" : props.editData.ROLE_ID,
        ROLE_NAME:
          props.editData.ROLE_NAME === null ? "" : props.editData.ROLE_NAME,
        ORGANIZATION:
          props.editData.ORGANIZATION === null
            ? ""
            : {
                key: props.editData.ORG_ID,
                value: props.editData.ORG_ID,
                label: props.editData.ORG_NAME,
              },
      });

      const roleId =
        props.editData.ROLE_ID === null || props.editData.ROLE_ID === undefined
          ? ""
          : props.editData.ROLE_ID.split(",");
      const roleName =
        props.editData.ROLE_NAME === null ||
        props.editData.ROLE_NAME === undefined
          ? ""
          : props.editData.ROLE_NAME.split(",");
      const role = [];
      for (var i = 0; i < roleId.length; i++) {
        role.push({
          key: roleId[i],
          value: roleId[i],
          label: roleName[i],
        });
      }
      setRoleList(role);
    }
  }, [props.editData]);

  const hideModal = () => {
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      SaveEditUser();
    }
  };

  function SaveEditUser() {
    let functionName = "";
    try {
      functionName = SaveEditUser.name;
      props.onLoading(true, "Modifying user, please wait...");
      const selectedRoleList = roleList.map((r) => r.key);
      const data = {
        USER_ID: editData.USER_ID,
        USER_FULL_NAME: editData.USER_FULL_NAME.trim(),
        USER_SHORT_NAME: editData.USER_SHORT_NAME.trim(),
        EMAIL: editData.EMAIL.trim(),
        ORG_ID: editData.ORGANIZATION.key,
        ORG_NAME: editData.ORGANIZATION.label,
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
        USER_ROLE_LIST: selectedRoleList,
      };
      http
        .put("api/users/UpdateUser", data, { timeout: 5000 })
        .then((response) => {
          if (response.data.DUPLICATE_EMAIL === true) {
            toast.error("Email " + response.data.EMAIL + " already exist.");
          }
          else {
            toast.success("User is successfully modified.");
            props.onReload();
            hideModal();
          }      
        })
        .catch((err) => {
          toast.error("Failed to modify user. Please try again.1");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to modify user. Please try again.2");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get Role List";
      http
        .get("api/users/GetRoleList?_user=" + userId)
        .then((response) => {
          const rolelist = [];
          for (var i = 0; i < response.data.length; i++) {
            rolelist.push({
              key: response.data[i].ROLE_ID,
              value: response.data[i].ROLE_ID,
              label: response.data[i].ROLE_NAME,
            });
          }
          setRoleListToBeSelect(rolelist);
        })
        .catch((err) => {
          common.c_LogWebError(props.page, functionName, err);
        });
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);

  function furtherValidateInput(id, val) {
    if (id === "EMAIL") {
      if (!common.EMAIL_REGEX.test(val) && val !== "") {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "Please enter a proper email.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        furtherValidateInput(id, val);
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      furtherValidateInput(id, val);
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectUserRoleHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectUserRoleHandler.name;
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          USER_ROLE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          USER_ROLE: "User role could not be empty.",
        }));
      }
      setRoleList([...val]);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setEditData((prevState) => ({
        ...prevState,
        [field]: val, //Document type
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header style={{ textAlign: "center" }}>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>MODIFY</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Select
            id="ORGANIZATION"
            label="Organization*:"
            type="text"
            options={dataToBeSelect.Organization}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.ORGANIZATION}
            value={editData.ORGANIZATION}
            onChange={(val) => selectionHandler(val, "ORGANIZATION")}
          />
          {/* <Comp.Input
            ref={userIdInputRef}
            id="USER_ID"
            label="User ID*:"
            name="User ID"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_ID}
            value={editData.USER_ID}
            // onChange={inputRequiredHandler}
            readOnly={true}
          /> */}
          <Comp.Input
            ref={fullNameInputRef}
            id="USER_FULL_NAME"
            label="Full Name*:"
            name="Full Name"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_FULL_NAME}
            value={editData.USER_FULL_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={userNameInputRef}
            id="USER_SHORT_NAME"
            label="User Name*:"
            name="User Name"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_SHORT_NAME}
            value={editData.USER_SHORT_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={emailInputRef}
            id="EMAIL"
            label="Email*:"
            name="Email"
            type="text"
            className="form-control"
            errorMessage={inputError.EMAIL}
            value={editData.EMAIL}
            onChange={inputRequiredHandler}
          />
          <Comp.Select
            id="USER_ROLE"
            label="User Role*:"
            type="text"
            options={roleListToBeSelect}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.USER_ROLE}
            value={roleList}
            onChange={selectUserRoleHandler}
            isMulti
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserModify;
